export const defaultCardDescriptions = {
  mastercard: 'Mastercard',
  mc: 'Mastercard',
  visa: 'Visa',
  vi: 'Visa',
};

export default (cardName, cardDescriptions = defaultCardDescriptions) =>
  cardName ? cardDescriptions[cardName.toLowerCase()] : null;
